import { halfPageManagerState as state } from './halfPageManagerState';
import * as consts from './halfPageManagerConstants';

export const halfPageManagerUpdateRepeaterHeights = (): void => {
  const repeaterBannerList: HTMLElement[] = state.getRepeaterBannerList();

  // Všem repeater bannerům nastavíme defaultní výšku
  repeaterBannerList.forEach((banner, index) => {
    const isLast = index === repeaterBannerList.length - 1;

    // Poslednímu banneru nastavíme zbylou výšku bočního bloku
    banner.style.height = `${
      isLast ? state.getLastBannerHeight() : consts.HALFPAGE_WRAPPER_DEFAULT_HEIGHT
    }px`;
  });
};
